function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1948(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10.59,
    height: 1.59,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 0.795
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.59,
    width: 10.59,
    height: 9.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 6.39
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.19,
    width: 10.59,
    height: 14.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 18.425
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.66,
    width: 10.59,
    height: 24.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 38.1
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50.54,
    width: 10.59,
    height: 28.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.32375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 64.725
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.91,
    width: 10.59,
    height: 32.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 95.24
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.58,
    width: 10.59,
    height: 36.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 129.865
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 148.15,
    width: 10.59,
    height: 44.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 170.16
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.17,
    width: 10.59,
    height: 44.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 214.605
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 237.03,
    width: 10.59,
    height: 46.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 260.245
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.46,
    width: 10.59,
    height: 46.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 306.825
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330.19,
    width: 10.59,
    height: 57.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.059
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 358.87
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.55,
    width: 10.59,
    height: 58.17,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 416.635
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 445.73,
    width: 10.59,
    height: 61.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 476.40000000000003
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 507.06,
    width: 10.59,
    height: 62.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.32375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 538.54
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 570.02,
    width: 10.59,
    height: 63.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 601.81
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 633.6,
    width: 10.59,
    height: 66.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.295,
    y: 666.8000000000001
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 0,
    width: 21.41,
    height: 37.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5683333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.295,
    y: 18.58
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 0,
    width: 22.05,
    height: 37.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.025,
    y: 18.58
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.05,
    y: 0,
    width: 23.81,
    height: 37.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.955,
    y: 18.58
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.87,
    y: 0,
    width: 24.45,
    height: 37.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.095,
    y: 18.58
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.32,
    y: 0,
    width: 27.3,
    height: 37.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.97,
    y: 18.58
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.62,
    y: 0,
    width: 29.45,
    height: 37.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.908333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.345,
    y: 18.58
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.07,
    y: 0,
    width: 37.78,
    height: 37.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4319999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.95999999999998,
    y: 18.58
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.85,
    y: 0,
    width: 38.72,
    height: 37.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.20999999999998,
    y: 18.58
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.57,
    y: 0,
    width: 40.98,
    height: 37.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.06,
    y: 18.58
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.55,
    y: 0,
    width: 41.32,
    height: 37.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.128888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.21000000000004,
    y: 18.58
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.87,
    y: 0,
    width: 41.39,
    height: 37.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1933333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.565,
    y: 18.58
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.26,
    y: 0,
    width: 41.59,
    height: 37.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.055,
    y: 18.58
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.85,
    y: 0,
    width: 49.54,
    height: 37.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1933333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.62,
    y: 18.58
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.39,
    y: 0,
    width: 54.15,
    height: 37.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.465,
    y: 18.58
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.55,
    y: 0,
    width: 59.43,
    height: 37.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1933333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.265,
    y: 18.58
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.98,
    y: 0,
    width: 63.3,
    height: 37.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.477333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.63,
    y: 18.58
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.27,
    y: 0,
    width: 72.73,
    height: 37.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4319999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.635,
    y: 18.58
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 37.16,
    width: 62.22,
    height: 45.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 59.94
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 82.72,
    width: 62.22,
    height: 52.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.226
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 108.85
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 134.98,
    width: 62.22,
    height: 64.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.443999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 167.14999999999998
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 199.32,
    width: 62.22,
    height: 64.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.888571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 231.68
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 264.04,
    width: 62.22,
    height: 66.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 297.39000000000004
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 330.74,
    width: 62.22,
    height: 67.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.786153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 364.42
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 398.1,
    width: 62.22,
    height: 71.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 433.96000000000004
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 469.82,
    width: 62.22,
    height: 75.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2219999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 507.39
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 544.96,
    width: 62.22,
    height: 76.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 583.335
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.59,
    y: 621.7,
    width: 62.22,
    height: 78.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.7,
    y: 660.85
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.82,
    y: 37.16,
    width: 70.45,
    height: 100.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.827777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.04499999999999,
    y: 87.19999999999999
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.26,
    y: 37.16,
    width: 71.6,
    height: 100.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.06,
    y: 87.19999999999999
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.86,
    y: 37.16,
    width: 72.27,
    height: 100.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.569999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.995,
    y: 87.19999999999999
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.13,
    y: 37.16,
    width: 97.17,
    height: 100.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.715,
    y: 87.19999999999999
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.3,
    y: 37.16,
    width: 99.42,
    height: 100.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.01,
    y: 87.19999999999999
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.72,
    y: 37.16,
    width: 105.03,
    height: 100.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.235,
    y: 87.19999999999999
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.75,
    y: 37.16,
    width: 111.25,
    height: 100.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.375,
    y: 87.19999999999999
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.82,
    y: 137.24,
    width: 106.88,
    height: 105.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.584
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.25999999999999,
    y: 190.16000000000003
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.82,
    y: 243.08,
    width: 106.88,
    height: 109.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.634285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.25999999999999,
    y: 297.71000000000004
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.82,
    y: 352.34,
    width: 106.88,
    height: 113.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.716363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.25999999999999,
    y: 409.05499999999995
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.82,
    y: 465.77,
    width: 106.88,
    height: 234.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.875555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.25999999999999,
    y: 582.885
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.7,
    y: 137.24,
    width: 249.59,
    height: 157.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.495,
    y: 216.16500000000002
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.28,
    y: 137.24,
    width: 270.72,
    height: 157.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.142307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.64,
    y: 216.16500000000002
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.7,
    y: 295.09,
    width: 520.3,
    height: 404.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.84999999999997,
    y: 497.54499999999996
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1948);
export default __webpack_public_path__ + "static/media/1948.738eb1015a7cbfd57030cb22babf7c68.svg";
export { ForwardRef as ReactComponent };